import { render, staticRenderFns } from "./Renew.vue?vue&type=template&id=5b246fc4&"
import script from "./Renew.vue?vue&type=script&lang=js&"
export * from "./Renew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports